<template>
  <div class="home" v-loading="loading">
    <div id="ele0">
      <Banner />
    </div>
    <div id="ele1" class="slide-two">
      <div
        class="parcel-tracking wow animate__pulse"
        data-wow-duration="1s"
        data-wow-delay="0.5s"
      >
        <h3>查快递</h3>
        <div class="divider"></div>
        <div class="input-div" @click="goRouter('parcel', '')">
          <p>
            请输入运单号或包裹号，多行单用逗号，空格或换行符隔开（最多可同时查询20条）
          </p>
          <div class="search">
            查询<img
              src="../assets/img/parcel/parcelTracking.png"
              mode="widthFix"
            />
          </div>
        </div>
      </div>
      <div class="logistics-message">
        <img
          class="wow animate__fadeInLeft"
          data-wow-duration="1s"
          data-wow-delay="0.5s"
          src="../assets/img/parcel/logisticsCar.png"
          mode="heightFix"
        />
        <div
          class="logistics-right wow animate__fadeInRight"
          data-wow-duration="1s"
          data-wow-delay="0.5s"
        >
          <h3>同城吉时达</h3>
          <div class="divider"></div>
          <p>用心服务，成就你我</p>
          <div class="strength">
            <img src="../assets/img/parcel/strength1.png" alt="" />
            <div class="strength-tip">
                <h6>全平台接单</h6>
                <p>支持淘宝、抖音、微信、快手、拼多多等多家平台店铺多店铺一站式接单</p>
            </div>
          </div>
          <div class="strength">
            <img src="../assets/img/parcel/strength2.png" alt="" />
            <div class="strength-tip">
                <h6>物流轨迹回传</h6>
                <p>物流轨迹实时回传，支持快递100、微信物流助手查询物流轨迹</p>
            </div>
          </div>
          <div class="strength">
            <img src="../assets/img/parcel/strength3.png" alt="" />
            <div class="strength-tip">
                <h6>支持主流打单软件</h6>
                <p>支持聚水潭、旺店通、快递助手、风火递等数十家打单软件电子面单打印</p>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div id="ele4" class="slide-practice">
          <div
                  class="practice-content wow animate__fadeInUp"
                  data-wow-duration="1s"
                  data-wow-delay="0.5s"
          >
              <h3>行业实践</h3>
              <h1>INDUSTRY PRACTICE</h1>
              <div class="practice-divider"></div>
              <p>
              </p>

              <swiper class="practice-swiper" :options="swiperOption">
                  <swiper-slide
                          v-for="(image, index) in practiceImages"
                          :key="index"
                  >
                      <img :src="image.src" :alt="image.alt" />
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
              </swiper>

          </div>
      </div>
      <div
              id="ele5"
              class="slide-system-intro wow animate__fadeIn"
              data-wow-duration="1s"
      >
          <div class="system-intro-content">
              <h3>系统介绍</h3>
              <h1>OUR SYSTEM</h1>
              <div class="system-divider"></div>
              <p>
              </p>
          </div>
          <img src="../assets/img/system/image.png" alt="系统介绍" />
      </div>
      <div id="ele2" class="slide-three">
          <div class="franchise-content wow animate__fadeInUp">
              <h3>商务洽谈</h3>
              <h1>FRANCHISE COOPERATION</h1>
              <div class="franchise-divider"></div>
              <h2>我们期待的您：</h2>

              <div class="partner-cards-container">
                  <div class="partner-card">

                      <div class="partner-card-text">
                          <h6>行业自配送商家</h6>
                          <p>
                              生鲜、海鲜、日百、粮油米面、鲜花、水站、牛羊肉、蛋糕、汽车零配件等行业自配送商家；
                          </p>
                      </div>
                  </div>

                  <div class="partner-card">

                      <div class="partner-card-text">
                          <h6>同城零售自配送商家</h6>
                          <p>
                              在微信小店、抖音小时达、美团、饿了么等同城零售或者社区团购行业自配送商家；
                          </p>
                      </div>
                  </div>

                  <div class="partner-card">

                      <div class="partner-card-text">
                          <h6>快递/驿站/服务商</h6>
                          <p>
                              在当地曾是或者现在是某家快递、驿站的加盟网点、众包平台的城市服务商；
                          </p>
                      </div>
                  </div>

                  <div class="partner-card">

                      <div class="partner-card-text">
                          <h6>云仓/配送商</h6>
                          <p>
                              在当地经营电商云仓、同城配、落地配或者从事淘宝闪购、美团闪购配送业务。
                          </p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
<!--    <div class="slide-four">-->
<!--      <div-->
<!--        class="news-message wow animate__pulse"-->
<!--        data-wow-duration="1s"-->
<!--        data-wow-delay="0.5s"-->
<!--      >-->
<!--        <div class="flex">-->
<!--          <h1>新闻中心</h1>-->
<!--          <h3>NEWS CENTER</h3>-->
<!--        </div>-->
<!--        <div class="flex">-->
<!--          <div-->
<!--            :class="active == 1 ? 'active-tab tabs' : 'tabs tab'"-->
<!--            @click="active = 1"-->
<!--          >-->
<!--            公司动态-->
<!--          </div>-->
<!--          <div-->
<!--            :class="active == 2 ? 'active-tab tabs' : 'tabs tab'"-->
<!--            @click="active = 2"-->
<!--          >-->
<!--            通知公告-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="content-nav-item" v-if="newsList && newsList.length">-->
<!--        <div-->
<!--          style="width: 100%;"-->
<!--          v-for="(item, index) in newsList"-->
<!--          :key="index"-->
<!--          @click="goRouter('newsdetails', item.id)"-->
<!--          :class="-->
<!--            index % 2 === 0-->
<!--              ? 'nav-item wow animate__fadeInLeft'-->
<!--              : 'nav-item wow animate__fadeInRight'-->
<!--          "-->
<!--          data-wow-duration="1s"-->
<!--          data-wow-delay="0.5s"-->
<!--        >-->
<!--          <div class="item-list">-->
<!--            <img class="item-img" :src="item.newsPicture" mode="widthFix" />-->
<!--            <div class="item-other">-->
<!--              <p class="item-list-title">{{ item.newsTitle }}</p>-->
<!--              <p class="item-list-time">{{ dataInfo(item.updateTime) }}</p>-->
<!--              <p class="item-list-content" v-html="item.newsContent"></p>-->
<!--              <div class="item-list-type">-->
<!--                {{ item.newsType == 1 ? "公司动态" : "通知公告" }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div v-if="newsList.length != index + 1" class="news-divider"></div>-->
<!--        </div>-->
<!--        <div class="pagination">-->
<!--          <p>{{ params.pageNo }} / {{ pageTotal }}</p>-->
<!--          <h6>Go to</h6>-->
<!--          <input-->
<!--            type="number"-->
<!--            v-model="goPageNo"-->
<!--            @blur="validatePageNo"-->
<!--            @keyup.enter="validatePageNo"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--      <div-->
<!--        v-else-->
<!--        class="noList wow animate__pulse"-->
<!--        data-wow-duration="1s"-->
<!--        data-wow-delay="1s"-->
<!--      >-->
<!--        <img src="../assets/img/parcel/noMessage.png" alt="" />-->
<!--        <p>暂无新闻</p>-->
<!--      </div>-->
<!--    </div>-->
    <div id="ele3" class="slide-five">
      <div
        class="about-us wow fadeInUp"
        data-wow-duration="1s"
        data-wow-delay="0.5s"
      >
        <h3>关于我们</h3>
        <h1>ABOUT US</h1>
        <p>
          吉林吉时达物流有限公司，是一家专注于同城配送和即时配送的物流企业，拥有自主研发的物流信息系统，支持各大电商平台及同城商户私域订单的同城配送和即时配送服务。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

// 导入 swiper
import { swiper, swiperSlide } from "vue-awesome-swiper";

const Banner = () => import("../components/banner.vue");
export default {
  name: "Home",
  components: {
    Banner,
      // 注册 swiper
      swiper,
      swiperSlide,
  },
  data() {
    return {
      active: 1,
      params: {
        pageNo: 1,
        pageSize: 3,
        newsType: 1,
      },
      newsList: [],
      pageTotal: 0,
      goPageNo: 1,
      loading: true,
      isElm: false, //是否首个

        // --- 新增图片列表 (请替换为您自己的图片) ---
        practiceImages: [
            { src: require("../assets/img/practice/image.png"), alt: "实践图片1" },
            { src: require("../assets/img/practice/image (1).png"), alt: "实践图片2" },
            { src: require("../assets/img/practice/image (2).png"), alt: "实践图片3" },
            { src: require("../assets/img/practice/image (3).png"), alt: "实践图片4" },
            { src: require("../assets/img/practice/image (4).png"), alt: "实践图片5" },
            { src: require("../assets/img/practice/image (5).png"), alt: "实践图片6" },
        ],

        // --- 新增 swiper 配置 ---
        swiperOption: {
            slidesPerView: 1, // 默认显示3张
            spaceBetween: 0, // 图片间距
            loop: true, // 循环播放
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // 响应式断点
            breakpoints: {
                // 当宽度 <= 1000px
                1000: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // 当宽度 <= 768px
                768: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            }
        },

    };
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true, // 在移动设备上触发动画（默认为true）
      live: true, // 对异步加载的内容进行操作（默认值为true）
      callback: function(box) {
        // 每次启动动画时都会触发回调,传入的参数是正在设置动画的DOM节点
      },
      scrollContainer: null, // 可选滚动容器选择器，否则使用window，
      resetAnimation: true, // 结束时重置动画（默认为true）
    });
    wow.init();

    this.handleClick();
    this.loading = false;
  },
  watch: {
    active(type) {
      this.params.pageNo = 1;
      this.params.newsType = type;
      this.handleClick();
    },
    $route: {
      handler: function(val, oldVal) {
        if (val.hash && val.hash == "#ele0") {
          this.isElm = true;
        } else {
          this.isElm = false;
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    // 新闻列表
    handleClick() {
      this.$api
        .newsList(this.params)
        .then((res) => {
          if (res.status == 200) {
            let data = res.data.data;
            this.newsList = data.list;
            this.pageTotal = Math.ceil(data.total / this.params.pageSize);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(() => {
          this.newsList = [];
        })
        .finally(() => {});
    },
    dataInfo(val) {
      const date = new Date(val);
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份是从 0 开始计数的，所以需要加 1
      const day = date.getDate();

      const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;
      return formattedDate;
    },
    validatePageNo() {
      if (this.goPageNo < 1) {
        this.goPageNo = 1;
      } else if (this.goPageNo > this.pageTotal) {
        this.goPageNo = this.pageTotal;
      }
      this.params.pageNo = this.goPageNo;
      this.handleClick();
    },
    goRouter(router, id) {
      this.$router.push({ name: router, params: { id: id } });
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1000px) {
  .logistics-message img {
    height: 302px;
    margin-right: 30px;
  }


  .slide-two {
    padding: 0 12%;
  }
}
@media screen and (min-width: 1000px) and (max-width: 1400px) {
  .logistics-message img {
    height: 335px;
    margin-right: 60px;
  }

  .slide-two {
    padding: 0 12%;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1600px) {
  .logistics-message img {
    height: 369px;
    margin-right: 90px;
  }

    .franchise-img img {
      width: 435px;
    }
  }
  .slide-two {
    padding: 0 12%;
  }

@media screen and (min-width: 1600px) {
  .logistics-message img {
    height: 369px;
    margin-right: 90px;
  }

  .slide-two {
    padding: 0 12%;
  }
}

.home {
  height: 100%;
  min-width: 1000px;
  min-height: 500px;
  position: relative;
}

.div {
  font-size: 24px;
}

.slide-two {
  padding-top: 80px;
  box-sizing: border-box;
  .parcel-tracking {
    h3 {
      font-size: 28px;
      color: #1d2129;
      line-height: 50px;
      margin: 0;
    }

    .divider {
      width: 55px;
      height: 6px;
      background-color: #084fff;
      margin-bottom: 22px;
    }

    .input-div {
      width: 100%;
      height: 120px;
      border-radius: 4px;
      background-color: #f7f7f7;
      position: relative;
      p {
        color: #c9cdd4;
        font-size: 12px;
        line-height: 30px;
        margin-left: 10px;
      }
      .search {
        width: 64px;
        height: 26px;
        background-color: #1d2129;
        border-radius: 2px;
        font-size: 12px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 12px;
        right: 12px;

        img {
          width: 12px;
          margin-left: 4px;
        }
      }
    }
  }
  .logistics-message {
    margin-top: 80px;
    display: flex;
    justify-content: left;
    align-items: start;
    .logistics-right {
      min-width: 250px;
      h3 {
        font-size: 28px;
        color: #1d2129;
        line-height: 50px;
        margin: 0;
      }

      .divider {
        width: 55px;
        height: 6px;
        background-color: #084fff;
        margin-bottom: 12px;
      }
      p {
        font-size: 14px;
        color: #1d2129;
      }

      .strength {
        display: flex;
        align-items: center;
        margin-top: 31px;
        img {
          width: 28px;
          height: 31px;
          margin-right: 12px;
          transition: all 0.4s ease;
        }

        .strength-tip {
          h6 {
            color: #1d2129;
            font-size: 18px;
            line-height: 25px;
            margin: 0;
            font-weight: 600;
          }
          p {
            color: #86909c;
            font-size: 14px;
            line-height: 20px;
            margin: 0;
            font-weight: 400;
          }
        }
      }
    }
  }
}

/* 新的“加盟合作”板块样式 */
.slide-three {
  padding: 80px 10%;
  background-color: #f7f7f7; /* 浅灰色背景，以突出卡片 */
  overflow: hidden;
  box-sizing: border-box;

  .franchise-content {
    width: 100%;
    max-width: 1280px; /* 限制最大宽度 */
    margin: 0 auto;
    text-align: center;

    h3 {
      font-size: 40px;
      margin-bottom: 12px;
      color: #1d2129;
    }
    h1 {
      font-size: 28px;
      margin: 0;
      color: #1d2129;
      font-weight: 600;
    }
    .franchise-divider {
      width: 48px;
      height: 4px;
      background-color: #084fff; /* 主题蓝色 */
      margin: 24px auto 40px;
    }
    h2 {
      font-size: 24px;
      color: #1d2129;
      font-weight: 600;
      margin-bottom: 40px;
    }
  }

  .partner-cards-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* 2x2 网格布局 */
    gap: 30px; /* 卡片间距 */
    text-align: left;
  }

  .partner-card {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: flex-start; /* 图标和文字顶部对齐 */
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    }

    img {
      width: 32px; /* 图标大小 */
      height: 32px;
      margin-right: 16px;
      margin-top: 4px; /* 轻微下移，与标题对齐 */
    }

    .partner-card-text {
      flex: 1;

      h6 {
        font-size: 18px;
        color: #1d2129;
        font-weight: 600;
        margin: 0 0 8px 0;
      }
      p {
        font-size: 14px;
        color: #4e5969;
        line-height: 1.6;
        margin: 0;
      }
    }
  }

  /* 响应式布局：当屏幕宽度小于1000px时，卡片变为单列 */
  @media screen and (max-width: 1000px) {
    .partner-cards-container {
      grid-template-columns: 1fr; /* 变为1列 */
    }
  }
}

.slide-four {
  margin: 80px auto;
  box-sizing: border-box;
  width: 80%;
  min-width: 1000px;

  .news-message {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h1 {
      font-size: 28px;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
      margin: 0;
    }
    h3 {
      font-size: 14px;
      color: #86909c;
      line-height: 20px;
      margin-left: 16px;
    }
    .flex {
      display: flex;
      justify-content: space-between;
      align-items: first baseline;
    }
    .tabs {
      width: 72px;
      height: 23px;
      line-height: 23px;
      font-size: 12px;
      margin-left: 36px;
      &:hover {
        cursor: pointer; /* 将光标样式更改为小手形状 */
      }
    }
    .tab {
      color: #1d2129;
    }
    .active-tab {
      color: #ffffff;
      background-color: #1d2129;
      text-align: center;
    }
  }
  .content-nav-item {
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .nav-item {
      border-radius: 4px;
      transition: box-shadow 0.3s ease; // 过渡效果

      &:hover {
        cursor: pointer; /* 将光标样式更改为小手形状 */
      }
      &:hover .item-list-content {
        color: #084fff;
      }

      .item-list {
        width: 100%;
        height: 212px;
        display: flex;
        justify-content: left;
        align-items: center;
        margin: 32px 0;

        .item-img {
          width: 337px;
          margin-right: 34px;
          background-color: #cecece;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center;
          background-origin: content-box;
        }

        .item-other {
          height: 212px;
          min-width: 600px;
        }

        &-time {
          color: #86909c;
          font-size: 12px;
          margin: 0;
        }

        &-type {
          width: 77px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border: 1px solid #c9cdd4;
          font-size: 12px;
          color: #4e5969;
        }

        &-title {
          font-family: PingFangSC, PingFang SC;
          color: #1d2129;
          font-size: 20px;
          margin: 14px auto 10px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        &-content {
          font-size: 16px;
          color: #4e5969;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2; /* 限制在一个块元素显示的文本的行数 */
          display: -webkit-box;
          -webkit-box-orient: vertical;
          white-space: normal !important;
          word-wrap: break-word;
          margin-bottom: 20px;
          ::v-deep img {
            display: none;
          }
        }
      }
    }

    .news-divider {
      background-color: #f2f3f5;
      height: 1px;
      width: 100%;
    }
    .pagination {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      text-align: center;
      p {
        font-family: AppleSystemUIFont;
        font-size: 14px;
        color: #4e5969;
        line-height: 36px;
        margin: 0;
      }
      h6 {
        font-family: AppleSystemUIFont;
        font-size: 14px;
        color: #86909c;
        line-height: 36px;
        margin: 0 7px 0 16px;
      }
      input {
        width: 40px;
        height: 36px;
        background: #f2f3f5;
        border: none;
        font-family: AppleSystemUIFont;
        text-align: center;
      }
    }
  }

  .noList {
    text-align: center;
    margin: 100px auto 160px;
    img {
      width: 168px;
      margin-bottom: 14px;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #86909c;
      font-style: normal;
    }
  }
}

.slide-five {
  width: 100%;
  min-width: 1000px;
  height: auto; /* 如果高度未知或想要根据内容调整 */
  text-align: center;
  color: #fff;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: url(../assets/img/aboutUs/aboutUsBgImg.png) no-repeat center;
  background-size: cover;
  background-position: center;

  .about-us {
    width: 100%;
    height: 503px;
    padding: 117px 20% 0;
    box-sizing: border-box;
    h3 {
      font-size: 16px;
      margin-bottom: 12px;
    }
    h1 {
      font-size: 50px;
      margin: 0;
    }
    p {
      font-size: 14px;
      margin-top: 24px;
    }
  }
}

::v-deep .el-tabs__nav {
  white-space: nowrap;
  position: relative;
  transition: transform 0.3s;
  float: right;
}

::v-deep input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.slide-practice {
  position: relative;
  padding: 80px 10%;
  background-color: #f7f7f7;
  text-align: center;
  box-sizing: border-box;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .practice-content {
    width: 100%;
    h3 {
      font-size: 40px;
      margin-bottom: 12px;
      color: #1d2129;
    }
    h1 {
      font-size: 28px;
      margin: 0;
      color: #1d2129;
      font-weight: 600;
    }
    .practice-divider {
      width: 48px;
      height: 4px;
      background-color: #084fff;
      margin: 24px auto 40px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #4e5969;
      max-width: 600px;
      margin: 0 auto;
    }
  }
}

.practice-swiper {
  position: relative;
  width: 100%;
  margin-top: 40px;

  .swiper-slide {
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    //height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: auto;
      //object-fit: cover;
    }
  }

  ::v-deep .swiper-button-next,
  ::v-deep .swiper-button-prev {
    color: #084fff;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    width: 40px;
    height: 40px;

    &::after {
      font-size: 20px;
      font-weight: 600;
    }
  }

  ::v-deep .swiper-button-prev {
    left: 10px;
  }
  ::v-deep .swiper-button-next {
    right: 10px;
  }
}

.slide-system-intro {
  h3 {
    font-size: 40px; /* <-- 从 16px 调大 */
    margin-bottom: 12px;
    color: #1d2129;
  }
  h1 {
    font-size: 28px; /* <-- 从 50px 调小 */
    margin: 0;
    color: #1d2129;
    font-weight: 600;
  }

  padding: 80px 0; /* 给板块上下留出空间 */
  background-color: #ffffff; /* 使用白色背景，您可以按需更改 */
  text-align: center;
  overflow: hidden;

  img {
    width: 80%; /* 图片宽度为父容器的80% */
    max-width: 1280px; /* 最大宽度，防止在大屏上过宽 */
    height: auto; /* 高度自动缩放 */
    border-radius: 8px; /* 轻微圆角 */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* 添加一点阴影 */
  }
}
</style>
